<template>
	<div v-loading="loading" class="base_scroll_page" style="padding: 15px 15px 15px 200px;">
		<!-- 区域选择 -->
		<AreaChoise @nodeClick="handleAreaChoiseSelect"></AreaChoise>
		<!-- 区域选择 end -->
		
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">姓名：</span>
					<el-input v-model="proxyer_name" class="b_inp" placeholder="姓名"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">手机号码：</span>
					<el-input v-model="proxyer_phone" class="b_inp" placeholder="手机号码"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">所属企业：</span>
					<el-input v-model="proxyer_firm" class="b_inp" placeholder="所属企业"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">创建人：</span>
					<el-input v-model="proxyer_creater" class="b_inp" placeholder="创建人"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="proxyer_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="proxyer_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="exportExcel">导出数据</el-button>
				<el-button type="primary" @click="handleAddProxyerClick">新增代理用户</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="phone"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="firmName"
						label="所属企业"
					>
					</el-table-column>
					<el-table-column
						prop="creater"
						label="创建人"
					>
					</el-table-column>
					<el-table-column
						prop="creatDate"
						label="创建时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewProxyerClick(scope.row)"
							>查看</el-button>
							<el-button
								@click="handleResetPasswordClick(scope.row)"
							>重置密码</el-button>
							<el-button
								@click="handleUnderlingOrganizationClick(scope.row)"
							>下属机构</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		<!-- 主体区域 end -->
		
		<!-- 新增代理用户弹出框 -->
		<Popup 
			v-model="addProxyer_popup_display"
			title="新增代理用户"
			confirmBtnText="添加"
			@confirmClick="handleAddProxyerPopupConfirmClick"
		>
			<div v-loading="add_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
					<el-input v-model="addProxyer_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addProxyerName_tip"><i class="b_icon"></i>请输入姓名</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
					<el-input v-model="addProxyer_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addProxyerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>擅长</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="addProxyer_special">
							<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addProxyerSpecial_tip"><i class="b_icon"></i>至少勾选一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属企业</span>
					<VDistpicker @province="handleAddProxyerAddrProvinceSelect" @city="handleAddProxyerAddrCitySelect" @area="handleAddProxyerAddrAreaSelect"></VDistpicker>
					<div class="base_tip"><template v-if="addProxyerAddr_tip"><i class="b_icon"></i>请选择代理区域</template></div>
					<el-select v-model="addProxyer_firm" placeholder="请先选择区域" style="width: 200px;">
						<el-option v-for="v in addProxyer_firms" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addProxyerFirm_tip"><i class="b_icon"></i>请选择所属企业</template></div>
			</div>
		</Popup>
		<!-- 新增代理用户弹出框 end -->
		
		<!-- 查看代理用户弹出框 -->
		<Popup 
			v-model="viewProxyer_popup_display"
			title="代理用户详情"
			confirmBtnText="修改"
			@confirmClick="handleUpdateProxyerClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label">姓名</span>
					<el-input :value="viewProxyer_name" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">账号</span>
					<el-input :value="viewProxyer_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">手机号</span>
					<el-input :value="viewProxyer_phone" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">所属企业</span>
					<el-input :value="viewProxyer_firm" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">代理区域</span>
					<div class="b_select">
						<el-select :value="viewProxyer_addr.provinceName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewProxyer_addr.cityName" disabled></el-select>
					</div>
					<div class="b_select">
						<el-select :value="viewProxyer_addr.areaName" disabled></el-select>
					</div>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">擅长</span>
					<el-input :value="viewProxyer_special" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建人</span>
					<el-input :value="viewProxyer_creater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">创建时间</span>
					<el-input :value="viewProxyer_creatDate" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改人</span>
					<el-input :value="viewProxyer_updater" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label">修改时间</span>
					<el-input :value="viewProxyer_updateDate" disabled></el-input>
				</div>
			</div>
		</Popup>
		<!-- 查看代理用户弹出框 end -->
		
		<!-- 修改代理用户弹出框 -->
		<Popup 
			v-model="updateProxyer_popup_display"
			title="更新代理用户"
			@confirmClick="handleUpdateProxyerPopupConfirmClick"
		>
			<div v-loading="update_loading" style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>账号</span>
					<el-input :value="updateProxyer_code" disabled></el-input>
				</div>
				<div class="base_form_row" style="margin-top: 20px;">
					<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
					<el-input v-model="updateProxyer_name" placeholder="姓名"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateProxyerName_tip"><i class="b_icon"></i>请输入姓名</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
					<el-input v-model="updateProxyer_phone" placeholder="手机号"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateProxyerPhone_tip"><i class="b_icon"></i>手机号格式错误</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>擅长</span>
					<div class="b_checkbox_group">
						<el-checkbox-group v-model="updateProxyer_special">
							<el-checkbox v-for="v in allDisease" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateProxyerSpecial_tip"><i class="b_icon"></i>至少勾选一项</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>所属企业</span>
					<VDistpicker :province="updateProxyer_addr.provinceName" :city="updateProxyer_addr.cityName" :area="updateProxyer_addr.areaName" @province="handleUpdateProxyerAddrProvinceSelect" @city="handleUpdateProxyerAddrCitySelect" @area="handleUpdateProxyerAddrAreaSelect"></VDistpicker>
					<div class="base_tip"><template v-if="updateProxyerFirm_tip"><i class="b_icon"></i>请选择代理区域</template></div>
					<el-select v-model="updateProxyer_firm" placeholder="请先选择区域" style="width: 200px;">
						<el-option v-for="(v, i) in updateProxyer_firms" :key="i" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateProxyerFirm_tip"><i class="b_icon"></i>请选择所属企业</template></div>
			</div>
		</Popup>
		<!-- 修改代理用户弹出框 end -->
		
		<!-- 重置密码弹出框 -->
		<reset-password 
			v-model="resetPassword_display"
			:oid="resetPassword_oid"
			:phone="resetPassword_phone"
			:code="resetPassword_code"
			@success="handleResetPasswordSuccess"
		></reset-password>
		<!-- 重置密码弹出框弹出框 end -->
		
		<!-- 下属机构弹出框 -->
		<underling-organization
			v-model="underlingOrganization_display"
			:uid="underlingOrganization_uid"
		></underling-organization>
		<!-- 下属机构弹出框 end -->
	</div>
</template>

<script>
	import AreaChoise from '../components/area_choise.vue';
	import Api from '../../../../api/index.js';
	import BaseMethods from '../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	import ResetPassword from './components/reset_password.vue';
	import UnderlingOrganization from './components/underling_organization.vue';
	
	export default {
		data () {
			return {
				loading: false,
				tableData: [],
				
				currentPage: 1,
				total: 0,
				
				proxyer_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				proxyer_name: '',
				proxyer_phone: '',
				proxyer_firm: '',
				proxyer_creater: '',
				proxyer_startTime: '',
				proxyer_endTime: '',
				
				add_loading: false,
				addProxyer_popup_display: false,
				addProxyer_name: '',
				addProxyer_phone: '',
				addProxyer_special: [],
				addProxyer_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				addProxyer_firms: [],
				addProxyer_firm: '',
				addProxyerName_tip: false,
				addProxyerPhone_tip: false,
				addProxyerSpecial_tip: false,
				addProxyerAddr_tip: false,
				addProxyerFirm_tip: false,
					
				viewProxyer_popup_display: false,
				viewProxyer_data: {},
				viewProxyer_name: '',
				viewProxyer_code: '',
				viewProxyer_phone: '',
				viewProxyer_firm: '',
				viewProxyer_addr: {
					provinceName: '',
					cityName: '',
					areaName: ''
				},
				viewProxyer_special: '',
				viewProxyer_creater: '',
				viewProxyer_creatDate: '',
				viewProxyer_updater: '',
				viewProxyer_updateDate: '',
				
				update_loading: false,
				updateProxyer_popup_display: false,
				updateProxyer_id: '',
				updateProxyer_code: '',
				updateProxyer_name: '',
				updateProxyer_phone: '',
				updateProxyer_special: [],
				updateProxyer_addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				updateProxyer_firms: [],
				updateProxyer_firm: '',
				updateProxyerName_tip: false,
				updateProxyerPhone_tip: false,
				updateProxyerSpecial_tip: false,
				updateProxyerAddr_tip: false,
				updateProxyerFirm_tip: false,
				
				resetPassword_display: false,
				resetPassword_phone: '',
				resetPassword_code: '',
				resetPassword_oid: '',
				
				underlingOrganization_display: false,
				underlingOrganization_uid: ''
			}
		},
		computed: {
			...mapState([
				'authInfo', 
				'allDisease'
			])
		},
		mounted () {
			this.getUserList();
		},
		methods: {
			/************************ @Ajax *******************************/
			// 请求数据
			getUserList () {
				const that = this;
				that.loading = true;
				var _requestData = {
					creater: that.proxyer_creater,
					endTime: that.proxyer_endTime,
					limit: 10,
					pageNum: that.currentPage,
					startTime: that.proxyer_startTime,
					uareaName: that.proxyer_addr.areaName,
					ucityName: that.proxyer_addr.cityName,
					ucode: null,
					udiseasesId: null,
					uenterpriseName: that.proxyer_firm,
					ufinderCategory: 2,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: that.proxyer_phone,
					uprovinceName: that.proxyer_addr.provinceName,
					username: that.proxyer_name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 1
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							that.tableData.push({
								id: res.data.data.data[i].uid,
								name: res.data.data.data[i].name || '',
								code: res.data.data.data[i].ucode || '',
								phone: res.data.data.data[i].phone || '',
								firmId: res.data.data.data[i].uenterpriseId || '',
								firmName: res.data.data.data[i].uenterpriseName || '',
								special: res.data.data.data[i].uexpert || '',
								creater: res.data.data.data[i].creater || '',
								creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '',
								provinceName: res.data.data.data[i].uprovinceName || '',
								provinceCode: res.data.data.data[i].uprovinceCode || '',
								cityName: res.data.data.data[i].ucityName || '',
								cityCode: res.data.data.data[i].ucityCode || '',
								areaName: res.data.data.data[i].uareaName || '',
								areaCode: res.data.data.data[i].uareaCode || '',
								updater: res.data.data.data[i].updater || '',
								updateDate: res.data.data.data[i].updateTime ? res.data.data.data[i].updateTime.split("T")[0] : ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除用户
			deleteUser(uid, oid) {
				const that = this;
				that.loading = true;
				var _requestData = {
					uCategory: 1,
					uId: uid,
					uenterpriseId: oid
				};
				Api.deleteUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.currentPage = 1;
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			/************************ @Events *******************************/
			// 选择城市
			handleAreaChoiseSelect (data) {
				if (data.sign == "P") {
					this.proxyer_addr.provinceCode = data.key.slice(0, 3);
					this.proxyer_addr.provinceName = data.label;
					this.proxyer_addr.cityCode = '';
					this.proxyer_addr.cityName = '';
					this.proxyer_addr.areaCode = '';
					this.proxyer_addr.areaName = '';
					this.currentPage = 1;
					this.getUserList();
				} else if (data.sign == "C") {
					this.proxyer_addr.provinceCode = data.parentKey.slice(0, 3);
					this.proxyer_addr.provinceName = data.parentLabel;
					this.proxyer_addr.cityCode = data.key + '000000';
					this.proxyer_addr.cityName = data.label;
					this.proxyer_addr.areaCode = '';
					this.proxyer_addr.areaName = '';
					this.currentPage = 1;
					this.getUserList();
				} else if (data.sign == "A") {
					this.proxyer_addr.provinceCode = data.grandKey.slice(0, 3);
					this.proxyer_addr.provinceName = data.grandLabel;
					this.proxyer_addr.cityCode = data.parentKey + '000000';
					this.proxyer_addr.cityName = data.parentLabel;
					this.proxyer_addr.areaCode = data.key + '000000';
					this.proxyer_addr.areaName = data.label;
					this.currentPage = 1;
					this.getUserList();
				} else {
					this.proxyer_addr.provinceCode = '';
					this.proxyer_addr.provinceName = '';
					this.proxyer_addr.cityCode = '';
					this.proxyer_addr.cityName = '';
					this.proxyer_addr.areaCode = '';
					this.proxyer_addr.areaName = '';
					this.currentPage = 1;
					this.getUserList();
				}
			},
			// 切换查询时间
			handleSearchStartTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick () {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getUserList();
			},
			// 点击页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getUserList();
				}
			},
			// 导出Excel数据
			exportExcel () {
				const that = this;
				that.loading = true;
				var _requestData = {
					creater: that.proxyer_creater,
					endTime: that.proxyer_endTime,
					limit: 10000,
					pageNum: 1,
					startTime: that.proxyer_startTime,
					uareaName: that.proxyer_addr.areaName,
					ucityName: that.proxyer_addr.cityName,
					ucode: null,
					udiseasesId: null,
					uenterpriseName: that.proxyer_firm,
					ufinderCategory: 2,
					uid: null,
					uloginerCategory: that.authInfo.ucategory,
					uphone: that.proxyer_phone,
					uprovinceName: that.proxyer_addr.provinceName,
					username: that.proxyer_name,
					userId: that.authInfo.uid,
					uenterpriseId: that.authInfo.uenterpriseId,
					functionType: 2
				};
				Api.findUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,姓名,账号,手机号,所属企业,创建人,创建时间,\n';
						for (var i = 0;i < res.data.data.data.length;i++) {
							str += `${ i+1 },`
							str += res.data.data.data[i].name || '';
							str += ',';
							str += res.data.data.data[i].ucode || '';
							str += '\t,';
							str += res.data.data.data[i].phone || '';
							str += '\t,';
							str += res.data.data.data[i].uenterpriseName || '';
							str += ',';
							str += res.data.data.data[i].creater || '';
							str += ',';
							str += res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : '';
							str += '\t,';
							str += '\n';
							// data.push({
							// 	name: res.data.data.data[i].name || '',
							// 	code: res.data.data.data[i].ucode || '',
							// 	phone: res.data.data.data[i].phone || '',
							// 	firmName: res.data.data.data[i].uenterpriseName || '',
							// 	creater: res.data.data.data[i].creater || '',
							// 	creatDate: res.data.data.data[i].createTime ? res.data.data.data[i].createTime.split("T")[0] : ''
							// });
						}
						BaseMethods.outputExcel(str, '代理用户');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击新增
			handleAddProxyerClick () {
				this.add_loading = false;
				this.addProxyer_name = '';
				this.addProxyer_phone = '';
				this.addProxyer_special = [];
				this.addProxyer_addr = {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				};
				this.addProxyer_firms = [];
				this.addProxyer_firm = '';
				this.addProxyerName_tip = false;
				this.addProxyerPhone_tip = false;
				this.addProxyerSpecial_tip = false;
				this.addProxyerAddr_tip = false;
				this.addProxyerFirm_tip = false;
				this.addProxyer_popup_display = true;
			},
			// 新增地址省份选择
			handleAddProxyerAddrProvinceSelect (data) {
				this.addProxyer_addr.provinceName = data.code ? data.value : '';
				this.addProxyer_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 新增地址城市选择
			handleAddProxyerAddrCitySelect (data) {
				this.addProxyer_addr.cityName = data.code ? data.value : '';
				this.addProxyer_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 新增地址区域选择
			handleAddProxyerAddrAreaSelect (data) {
				const that = this;
				that.addProxyer_addr.areaName = data.code ? data.value : '';
				that.addProxyer_addr.areaCode = data.code ? `${ data.code }000000` : '';
				that.add_loading = true;
				var _requestData = {
					uAreaCode: that.addProxyer_addr.areaCode,
					uCategory: 2,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(_requestData).then((res) => {
					that.add_loading = false;
					if (res.data.success) {
						that.addProxyer_firms = [];
						res.data.data.forEach((v) => {
							that.addProxyer_firms.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						that.addProxyer_firm = that.addProxyer_firms.length
							? that.addProxyer_firms[0].id
							: '';
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.add_loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击新增代理用户弹出框确认按钮
			handleAddProxyerPopupConfirmClick () {
				const that = this;
				if (!that.addProxyer_name.trim()) {	// 校验姓名
					that.addProxyerName_tip = true;
					return false;
				} else {
					that.addProxyerName_tip = false;
				}
				if (!that.phoneReg.test(that.addProxyer_phone)) {	// 校验手机号
					that.addProxyerPhone_tip = true;
					return false;
				} else {
					that.addProxyerPhone_tip = false;
				}
				if (!that.addProxyer_special.length) {	// 校验擅长
					that.addProxyerSpecial_tip = true;
					return false;
				} else {
					that.addProxyerSpecial_tip = false;
				}
				if (!that.addProxyer_addr.areaCode) {	// 校验代理区域
					that.addProxyerAddr_tip = true;
					return false;
				} else {
					that.addProxyerAddr_tip = false;
				}
				if (!that.addProxyer_firm) {	// 校验所属企业
					that.addProxyerFirm_tip = true;
					return false;
				} else {
					that.addProxyerFirm_tip = false;
				}
				that.loading = true;
				var _requestData = {
					"id": null,
					"openUmBUserVo": {
						"isExamine": null,
						"uareaCode": that.addProxyer_addr.areaCode,
						"uareaName": that.addProxyer_addr.areaName,
						"ucategory": 2,
						"ucategorySpecific": null,
						"ucityCode": that.addProxyer_addr.cityCode,
						"ucityName": that.addProxyer_addr.cityName,
						"ucode": that.addProxyer_phone,
						"ucreate": null,
						"ucreateTs": null,
						"uenterpriseId": that.addProxyer_firm,
						"uexpert": that.addProxyer_special.join(","),
						"uid": null,
						"ulevel": null,
						"uname": that.addProxyer_name,
						"unationalityCode": null,
						"unationalityName": null,
						"uphone": that.addProxyer_phone,
						"uprovinceCode": that.addProxyer_addr.provinceCode,
						"uprovinceName": that.addProxyer_addr.provinceName,
						"usex": null
					},
					"openUmWUserVo": {
						"u_r_name": null,
						"uaddressToAreaCode": null,
						"uaddressToAreaName": null,
						"uaddressToCityCode": null,
						"uaddressToCityName": null,
						"uaddressToNationalityCode": null,
						"uaddressToNationalityName": null,
						"uaddressToProvinceCode": null,
						"uaddressToProvinceName": null,
						"uage": null,
						"uareaCode": null,
						"uareaName": null,
						"uattendingDoctor": null,
						"ucityCode": null,
						"ucityName": null,
						"ucode": null,
						"uid": null,
						"uleftCva": null,
						"uleftNeva": null,
						"umemo": null,
						"unationalityCode": null,
						"unationalityName": null,
						"uoverspreadEye": null,
						"uphone": null,
						"uprovinceCode": null,
						"uprovinceName": null,
						"urightCva": null,
						"urightNeva": null,
						"usex": null
					},
					"type": "b",
					"ucode": that.authInfo.ucode
				};
				Api.addUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.addProxyer_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击查看
			handleViewProxyerClick (data) {
				this.viewProxyer_data = data;
				this.viewProxyer_name = data.name;
				this.viewProxyer_code = data.code;
				this.viewProxyer_phone = data.phone,
				this.viewProxyer_firm = data.firmName;
				this.viewProxyer_addr = {
					provinceName: data.provinceName,
					cityName: data.cityName,
					areaName: data.areaName
				};
				this.viewProxyer_special = this.mapDiseaseToName(data.special);
				this.viewProxyer_creater = data.creater;
				this.viewProxyer_creatDate = data.creatDate;
				this.viewProxyer_updater = data.updater;
				this.viewProxyer_updateDate = data.updateDate;
				this.viewProxyer_popup_display = true;
			},
			// 点击修改
			handleUpdateProxyerClick () {
				const that = this;
				var data = that.viewProxyer_data;
				this.viewProxyer_popup_display = false;
				this.updateProxyer_id = data.id;
				this.updateProxyer_code = data.code;
				this.updateProxyer_name = data.name;
				this.updateProxyer_phone = data.phone;
				this.updateProxyer_special = [];
				for (var i = 0;i < data.special.split(",").length;i++) {
					this.updateProxyer_special.push(parseInt(data.special.split(",")[i]));
				}
				this.updateProxyer_addr = {
					provinceName: data.provinceName,
					provinceCode: data.provinceCode,
					cityName: data.cityName,
					cityCode: data.cityCode,
					areaName: data.areaName,
					areaCode: data.areaCode
				};
				this.updateProxyer_firms = [];
				this.updateProxyer_firm = '';
				this.updateProxyerName_tip = false;
				this.updateProxyerPhone_tip = false;
				this.updateProxyerSpecial_tip = false;
				this.updateProxyerAddr_tip = false;
				this.updateProxyerFirm_tip = false;
				that.loading = true;
				var _requestData = {
					uAreaCode: that.updateProxyer_addr.areaCode,
					uCategory: 2,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateProxyer_firms = [];
						var _already = false;
						res.data.data.forEach((v) => {
							data.firmId == v.uenterpriseId && (_already = true);
							that.updateProxyer_firms.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						_already
							? (that.updateProxyer_firm = data.firmId)
							: (that.updateProxyer_firm = that.updateProxyer_firms.length
								? that.updateProxyer_firms[0].id
								: ''
							);
						that.updateProxyer_popup_display = true;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改代理用户地址省份选择
			handleUpdateProxyerAddrProvinceSelect(data) {
				this.updateProxyer_addr.provinceName = data.code ? data.value : '';
				this.updateProxyer_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 修改代理用户地址城市选择
			handleUpdateProxyerAddrCitySelect(data) {
				this.updateProxyer_addr.cityName = data.code ? data.value : '';
				this.updateProxyer_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 修改代理用户地址区域选择
			handleUpdateProxyerAddrAreaSelect(data) {
				const that = this;
				that.updateProxyer_addr.areaName = data.code ? data.value : '';
				that.updateProxyer_addr.areaCode = data.code ? `${ data.code }000000` : '';
				that.update_loading = true;
				var _requestData = {
					uAreaCode: that.updateProxyer_addr.areaCode,
					uCategory: 2,
					uCode: that.authInfo.ucode
				};
				Api.findFirmsByArea(_requestData).then((res) => {
					that.update_loading = false;
					if (res.data.success) {
						that.updateProxyer_firms = [];
						res.data.data.forEach((v) => {
							that.updateProxyer_firms.push({
								id: v.uenterpriseId,
								name: v.uenterpriseName
							});
						});
						that.updateProxyer_firm = that.updateProxyer_firms.length
							? that.updateProxyer_firms[0].id
							: '';
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.update_loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击修改代理用户弹框确定按钮
			handleUpdateProxyerPopupConfirmClick() {
				const that = this;
				if (!that.updateProxyer_name.trim()) {
					that.updateProxyerName_tip = true;
					return false;
				} else {
					that.updateProxyerName_tip = false;
				}
				if (!that.phoneReg.test(that.updateProxyer_phone)) {
					that.updateProxyerPhone_tip = true;
					return false;
				} else {
					that.updateProxyerPhone_tip = false;
				}
				if (!that.updateProxyer_special.length) {
					that.updateProxyerSpecial_tip = true;
					return false;
				} else {
					that.updateProxyerSpecial_tip = false;
				}
				if (!that.updateProxyer_addr.areaCode) {
					that.updateProxyerAddr_tip = true;
					return false;
				} else {
					that.updateProxyerAddr_tip = false;
				}
				if (!that.updateProxyer_firm) {
					that.updateProxyerFirm_tip = true;
					return false;
				} else {
					that.updateProxyerFirm_tip = false;
				}
				that.loading = true;
				var _requestData = {
					"age": null,
					"name": that.updateProxyer_name,
					"phone": that.updateProxyer_phone,
					"uareaCode": that.updateProxyer_addr.areaCode,
					"uareaName": that.updateProxyer_addr.areaName,
					"uattendingDoctor": null,
					"ucategory": 1,
					"ucityCode": that.updateProxyer_addr.cityCode,
					"ucityName": that.updateProxyer_addr.cityName,
					"ucode": that.updateProxyer_code,
					"uenterpriseId": that.updateProxyer_firm,
					"uexpert": that.updateProxyer_special.join(","),
					"uid": that.updateProxyer_id,
					"unationalityCode": null,
					"unationalityName": null,
					"uprovinceCode": that.updateProxyer_addr.provinceCode,
					"uprovinceName": that.updateProxyer_addr.provinceName
				};
				Api.updateUser(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.updateProxyer_popup_display = false;
						that.$message({
							message: res.data.message,
							type: 'success'
						});
						that.getUserList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 点击重置密码
			handleResetPasswordClick(data) {
				this.resetPassword_phone = data.phone;
				this.resetPassword_code = data.code;
				this.resetPassword_oid = data.firmId;
				this.resetPassword_display = true;
			},
			// 重置密码成功
			handleResetPasswordSuccess(msg) {
				this.$message.success(msg);
				this.resetPassword_display = false;
			},
			// 点击下属机构
			handleUnderlingOrganizationClick(obj) {
				this.underlingOrganization_uid = obj.id;
				this.underlingOrganization_display = true;
			},
			// 点击删除
			handleDeleteClick(msg) {
				const that = this;
				that.$confirm(
					'此操作将删除该用户，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteUser(msg.id, msg.firmId);
					}
				).catch(
					() => {}
				);
			},
			
			/************************ @Function *******************************/
			// 把病理类型转换成名称
			mapDiseaseToName (diseaseStr) {
				var _diseaseList = diseaseStr.split(","),
					result = [];
				for (var i = 0;i < _diseaseList.length;i++) {
					for (var w = 0;w < this.allDisease.length;w++) {
						if (_diseaseList[i] == this.allDisease[w].id) {
							result.push(this.allDisease[w].name);
						}
					}
				}
				return result.join("，");
			},
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.proxyer_startTime && this.proxyer_endTime) {
					var startTime = new Date(this.proxyer_startTime).getTime(),
						endTime = new Date(this.proxyer_endTime).getTime();
					if (endTime < startTime) {
						this.proxyer_endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		},
		components: {
			AreaChoise,
			ResetPassword,
			UnderlingOrganization
		}
	}
</script>

<style scoped>
</style>
